import type { DatatableField } from 'containers/ReportingEngine/Widgets/types';
import { createViewColumn } from 'containers/Ticketing/_api/useGetBoardViewDetails/typeHelper';
import type { TicketLayoutField } from 'containers/Ticketing/_api/useGetTicketLayoutDetails/types';
import type { TicketBoardViewColumn } from 'containers/Ticketing/_api/useGetBoardViewDetails/types';

interface ViewableSystemFieldConfig {
  ticketFieldId: string;
  label: string;
}

// This file is used to convert system fields retrieved from the ticketing service
// to the various forms it is consumed in currently within the reporting view
// previously these field were hardcoded in  ReportView/constants.ts: hardCodedFields

export type SystemLayoutField = Omit<TicketLayoutField, 'systemField'> & {
  systemField: true;
};

// taken from validator. if you change this
// make sure it aligns with the system fields there
export enum TicketingSystemField {
  UpdatedBy = 'updated_by',
  UpdatedAt = 'updated_at',
  CreatedBy = 'created_by',
  CreatedAt = 'created_at',
  DeletedBy = 'deleted_by',
  DeletedAt = 'deleted_at',
  Subject = 'subject',
  LayoutId = 'layout_id',
  AccountTicketId = 'account_ticket_id',
}

export enum TicketingCommonFields {
  Assignee = 'Assignee',
  Requestor = 'Requestor',
  Status = 'Status',
}

function createViewableSystemFieldsConfig(
  field: SystemLayoutField
): ViewableSystemFieldConfig {
  switch (field.name) {
    case TicketingSystemField.Subject:
      return {
        ticketFieldId: field.id,
        label: 'Subject',
      };
    case TicketingSystemField.CreatedAt:
      return {
        ticketFieldId: field.id,
        label: 'Created At',
      };
    case TicketingSystemField.CreatedBy:
      return {
        ticketFieldId: field.id,
        label: 'Created By',
      };
    case TicketingSystemField.UpdatedAt:
      return {
        ticketFieldId: field.id,
        label: 'Updated At',
      };
    case TicketingSystemField.UpdatedBy:
      return {
        ticketFieldId: field.id,
        label: 'Updated By',
      };
    case TicketingSystemField.AccountTicketId:
      return {
        ticketFieldId: field.id,
        label: 'Matter Id',
      };
    case TicketingSystemField.LayoutId:
      return {
        ticketFieldId: field.id,
        label: 'Matter Layout',
      };
    case TicketingSystemField.DeletedAt:
      return {
        ticketFieldId: field.id,
        label: 'Deleted At',
      };
    case TicketingSystemField.DeletedBy:
      return {
        ticketFieldId: field.id,
        label: 'Deleted By',
      };
    default:
      throw new Error(`system field is not found: ${field.name} `);
  }
}

// The main thing this does is change the label of a System Ticketing Field to be more user friendly
//   Also maps from the core Ticketing Fields type to the ReportingEngine type
//   TODO: This functionality could use a rework for clarity
export function createSystemDatatableField(
  field: SystemLayoutField
): DatatableField {
  const config = createViewableSystemFieldsConfig(field);
  return {
    id: config.ticketFieldId,
    originalName: field.name,
    type: field.fieldType,
    label: config.label,
    position: 0,
  };
}

// The main thing this does is change the label of a System Ticketing Field to be more user friendly
//   Also maps from the core Ticketing Fields type to the Board View specific one
//   TODO: This functionality could use a rework for clarity
export function createSystemViewColumn(
  field: SystemLayoutField
): TicketBoardViewColumn {
  const config = createViewableSystemFieldsConfig(field);
  return createViewColumn({
    ...config,
  });
}
